<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column label="Programme" [derrors]="derrors">
                    <input
                      formControlName="realEstateProgramName"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column label="Nom du promoteur" [derrors]="derrors">
                    <input
                      formControlName="realEstatePromoterName"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column
                    label="Référence du bien"
                    [derrors]="derrors"
                  >
                    <input formControlName="realEstateReference" type="text" />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Loyer previsionel"
                    [derrors]="derrors"
                  >
                    <input
                      formControlName="realEstateRent"
                      type="number"
                      fraction="2"
                    />
                    <i>€/mois</i>
                  </pr-input-column>
                </div>
                <!-- <div class="col col-md-6">
                <pr-input-column label="Etage" [derrors]="derrors">
                  <input formControlName="realEstateFloor" type="text" />
                </pr-input-column>
              </div> -->
              </div>
              <!-- <div class="row">
            <div class="col-md-6">
              <pr-input-radio formControlName="realEstateHasParking" columns="3" [toggle]="true" [isDefault]="false"
                label="Place de stationnement">
              </pr-input-radio>
            </div>
            <div class="col-md-6">
              <pr-input-radio formControlName="realEstateHasCellar" columns="3" [toggle]="true" [isDefault]="false"
                label="Cave">
              </pr-input-radio>
            </div>
          </div> -->
              <!-- <div class="row">
          <div class="col col-md-12">
            <pr-input-column label="Description du bien" [derrors]="derrors">
              <textarea class="full-w" type="text" placeholder="Commencez à écrire ici" rows="6"
              formControlName="realEstateDescription"></textarea>
            </pr-input-column>
          </div>
        </div> -->
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
